import axios from "../axiosConfig";

class Routes {
  getCalendarEvents(params) {
    return axios.get("/scheduled-appointment", { params });
  }
  getByAppointment(appointmentId) {
    return axios.get(`/scheduled-appointment/by-appointment/${appointmentId}`);
  }
  createScheduledAppointment(data) {
    return axios.post("/scheduled-appointment", data);
  }
  updateScheduledAppointment(id, data) {
    return axios.patch(`/scheduled-appointment/${id}`, data);
  }
}

export default new Routes();
